import { useEffect, useState } from "react";
import "../style.css";

export default function PageLoader({ children }) {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const alreadyVisited = localStorage.getItem("visited");

    // show loader only first visit
    if (!alreadyVisited) {
      setLoading(true);
      localStorage.setItem("visited", "true");

      const timer = setTimeout(() => {
        setLoading(false);
      }, 1300);

      return () => clearTimeout(timer);
    }
  }, []);

  if (loading) {
    return (
      <div className="page-entry-loader spinner-style">
        <div className="spinner-logo">
          <div className="spinner"></div>
          <h1>Lappy</h1>
         
        </div>
      </div>
    );
  }

  return children;
}
